<template>
  <div class="poster-container">
    <postCard :info="info" :appKey="option.appKey" :type="option.relationType" v-if="info"></postCard>
  </div>
</template>
<script>
import postCard from './components/postCard.vue'
import { relayGet } from '@/api/exhibitor'
export default {
  props:{},
  components:{postCard},
  data() {
    return {
      option: {},
      info:""
    }
  },
  methods: {
    // meetingType=EXHIBITION&meetingCode=EX1779409368110931968&relationCode=ER1779744786522071040&relationType=EXHIBITOR
    getQuery() {
      this.option.eventKey =  this.$route.query?.eventKey || ''
      this.option.appKey =  this.$route.query?.appKey || ''
      this.option.token =  this.$route.query?.token || ''
     
      this.option.meetingType = this.$route.query?.meetingType || "";
      this.option.meetingCode = this.$route.query?.meetingCode || "";
      this.option.relationCode = this.$route.query?.relationCode || "";
      this.option.relationType = this.$route.query?.relationType || "";
      this.option.width = this.$route.query?.width || '300';

      localStorage.setItem('eventKey', this.eventKey)
      localStorage.setItem('appKey', this.appKey)
      localStorage.setItem('token', this.token)
    },
    async getData() {
      if(!this.option.meetingCode) return
      var headerClientInfo = { language: 'CN', eventKey: this.option.eventKey, appKey: this.option.appKey }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.option.token,
      }
      try {
        // this.$toast.loading('加载中...')
        let params = {
          meetingCode: this.option.meetingCode,
          meetingType: this.option.meetingType,
          relationCode: this.option.relationCode,
          relationType: this.option.relationType,
          width: this.option.width
        };
        let resp = await relayGet(headers, params)
        this.info = resp.data
        console.log("resp",resp)
      } catch (error) {
        
      }
  
		},
  },
  mounted() {
    console.log(this.$route.query)
    this.getQuery()
    this.getData()
  }
}
</script>
<style lang="less" scoped>
.poster-container {
  min-height: 100vh;
  padding: 14px 12px;
  background: #F5F5F5;
  box-sizing: border-box;
}
 

</style>